import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturasUploadedFiles = (viaturaId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/viaturas/${viaturaId}/files`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURAS_UPLOADED_FILES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturasUploadedFiles;